import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as bomSerialsSelectors, actions as bomSerialsActions } from 'ducks/pickSlips/bomSerials';
import { fetchSerials } from 'api/pickSlips/bom';
import { actions as filterActions } from 'ducks/common/filters';
import { selectors as pickSlipSelectors } from 'ducks/pickSlips/pickSlipTransaction';
import { IApplicationState } from 'ducks/reducers';
import { selectors as bomSelectors } from 'ducks/pickSlips/bom';

const params = new URLSearchParams(location.search);

export const mapStateToProps = (state: IApplicationState) => ({
  gridName: 'PSBOMSerials',
  columnDefs: bomSerialsSelectors.lineColumns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: bomSerialsSelectors.gridOptions(state),
  reqParams: ((pickSlipSelectors.selected(state) || params.get('DespatchId')) && (bomSelectors.selected(state) || params.get('BOMLineNumber')))
    &&
    {
      DespatchId: (pickSlipSelectors.selected(state) && pickSlipSelectors.selected(state).DespatchId) || params.get('DespatchId'),
      BOMLineNumber: (bomSelectors.selected(state) && bomSelectors.selected(state).LineNumber) || params.get('BOMLineNumber')
    },
  apiMethod: fetchSerials
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: bomSerialsActions.setSelected,
  applyFilters: filterActions.applyFilters
};
